import React, { StrictMode } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store";
import Firebase, { FirebaseContext } from "./services/firebase";
import "./css/index.css";
import App from "./containers/App";

import { ThemeProvider, createTheme } from "@mui/material/styles";
import {primary, secondary} from "./assets/colorPallet";

const theme = createTheme({
  palette: {
    primary: {
      main: primary
    },
    secondary: {
      main: secondary
    }
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          maxWidth: "12rem",
          "&.Mui-disabled": {
            backgroundColor: "#eceff1",
          },
        },
        input: {
          "&.Mui-disabled": {
            WebkitTextFillColor: "black",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: "#fbe9e7",
          WebkitTextFillColor: "black",
        },
      },
    },
  },
});

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
      <FirebaseContext.Provider value={new Firebase()}>
        <StrictMode>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </StrictMode>
      </FirebaseContext.Provider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
